import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { EmpAdditionalDocUploadGuard } from '../core/guards/emp-additional-doc-upload.guard';
import { PrivacyGuard } from '../core/guards/privacy.guard';
import { AntiForgeryResolver } from '../core/resolvers/anti-forgery.resolver';
import { EmpAdditionalUploadComponent } from './components/emp-additional-upload/emp-additional-upload.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserComponent } from './user.component';

const routes: Routes = [
    { path: '', redirectTo: 'user-profile/home', pathMatch: 'full' },
  { path: 'user-profile', redirectTo: 'user-profile/home' },
  {
    path: 'upload/:id',
    component: EmpAdditionalUploadComponent,
    canActivate: [EmpAdditionalDocUploadGuard],
    resolve: {
      xsrf: AntiForgeryResolver
    }
  },
    {
        path: '',
        component: UserComponent,
         canActivateChild: [AuthGuard,PrivacyGuard],
        // data: { claim: 'IMM', name: 'Immigration' },
        children: [
            { path: 'home', redirectTo: 'user-profile' },
            {
                path: '',
                component: UserComponent,
                data: {  name: 'Profile', breadcrumb: '' }
            },
            {
                path: 'profile',
                component: UserProfileComponent,
                resolve: {
                    xsrf: AntiForgeryResolver
                  },
                data: {  name: 'Profile',
                         breadcrumb: 'Profile',
                         isSearch: false,
                         showAppRej: false }
          },
          
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class UserRoutingModule { }
